import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import { getAnonymizedFieldValue } from 'root/utils/forms/getAnonymizedFieldValue';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import { FormGTMObjectConstructor } from 'root/utils/tracking/GA4/formTracking';

const isAgnosticWizardForm = formEl => {
    return (
        formEl.dataset.formName &&
        formEl.dataset.formName === 'other_watch_demo_wizard_lightbox'
    );
};

const sendWizardFormElementEventToGTM = (formEl, eventType) => {
    const formTrackingName = formEl.dataset.formTrackingName;
    const formStage = formEl.stage.value;
    if (formTrackingName && formStage) {
        gtm.wizardFormElement(
            `product-dynamic|${formTrackingName}|${formStage}`
        ).sendEvent(eventType);
    }
};

const getGTVTrackingValues = (trackingValue, fieldName, fieldValue) => {
    if (fieldName === 'estimated_annual_gtv' && fieldName && trackingValue) {
        return {
            trackingValue,
            trackingName: 'gtv',
        };
    }
    return {
        trackingValue: fieldValue,
        trackingName: fieldName,
    };
};
const sendWizardFormFieldEventToGTM = (formEl, clickedOptionEl) => {
    if (formEl) {
        const fieldName = clickedOptionEl.dataset.wizardFormStoreField?.split('|')[0];
        const productName = formEl.querySelector('input[name=product]')?.value;
        const formStage = formEl.querySelector('input[name=stage]')?.value;
        const formTrackingName = formEl.dataset.formTrackingName;
        const fieldValue = getAnonymizedFieldValue(clickedOptionEl, true);
        const { trackingValue: fieldTrackingValue, trackingName: fieldTrackingName } =
            getGTVTrackingValues(
                clickedOptionEl.dataset.wizardTracking,
                fieldName,
                fieldValue
            );
        if (
            fieldName &&
            productName &&
            formStage &&
            formTrackingName &&
            fieldTrackingName
        ) {
            const formGTMObjectConstructor = new FormGTMObjectConstructor(formEl);
            if (clickedOptionEl.hasAttribute('data-wizard-form-adp-field')) {
                GoogleTagManager.sendEvent(
                    formGTMObjectConstructor.getFormGTMObject(
                        'field_validation_error',
                        fieldValue,
                        fieldName
                    )
                );
                return;
            }
            GoogleTagManager.sendEvent(
                formGTMObjectConstructor.getFormGTMObject(
                    'field_completed',
                    fieldTrackingValue,
                    fieldTrackingName
                )
            );
            gtm.wizardFormField(
                `${productName}|${formTrackingName}|${formStage}`
            ).sendEvent(`${fieldTrackingName}|${fieldTrackingValue}`);
        }
    }
};

export {
    isAgnosticWizardForm,
    sendWizardFormElementEventToGTM,
    sendWizardFormFieldEventToGTM,
};
